import { pageContentBlocks } from 'app/blocks'
import { gql } from 'graphql-request'

export type CollectionType = 'Collection' | 'Tag' | 'MemberTier'

export const createCollectionFragment = (
  type: CollectionType = 'Collection',
  includeContent?: boolean
) => gql`
  ${includeContent ? pageContentBlocks : ''}
  fragment collection on ${type} {
    id
    name
    subtitle
    slug
    thumbnail {
      id
      sizes {
        square {
          url
        }
      }
    }
    heroImage {
      id
      sizes {
        thumbnail2x {
          url
        }
      }
    }
    episodeOverlay {
      id
      sizes {
        thumbnail {
          url
        }
        thumbnail2x {
          url
        }
      }
    }
    itemCount
    ${
      includeContent
        ? `
    pageContent {
      __typename
      ...richTextFragment
      ...bannerFragment
      ...imageFragment
      ...videoFragment
      ...externalImageFragment
      ...faqsFragment
      ...productGridFragment
      ...formFragment
      ...redeemCollectableFragment
      ...buttonFragment
      ...collectibleProgressFragment
    }`
        : ''
    }
  }
`
